import { render, staticRenderFns } from "./MembersSideBar.vue?vue&type=template&id=c0b56000&scoped=true&"
import script from "./MembersSideBar.vue?vue&type=script&lang=js&"
export * from "./MembersSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MembersSideBar.vue?vue&type=style&index=0&id=c0b56000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b56000",
  null
  
)

export default component.exports